import { Spinner } from "common/components/Spinner";
import { authenticated } from "common/selectors/auth.selectors";
import { currentUser } from "common/selectors/user.selectors";
import * as React from "react";
import { useSelector } from "react-redux";

export interface ProtectedRouteProps {
  element?: React.JSX.Element;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const isAuthenticated = useSelector(authenticated);
  const user = useSelector(currentUser);

  if (isAuthenticated && user?.loading) return <Spinner loadingSelector={() => true} />;
  return element ? element : null;
};
